import { apiClient } from '@/lib/api-client';
import { API_CONFIG } from '@/lib/config';

const BASE_URL = API_CONFIG.BASE;

export interface AllowedDomain {
  _id: string;
  name: string;
  allowedDomains: string[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface AllowedDomainIn {
  name: string;
  allowedDomains: string[];
  isActive: boolean;
}

export async function getAllowedDomains(): Promise<AllowedDomain[]> {
  const { data } = await apiClient.get(`${BASE_URL}/allowed-domains`);
  return data.data || [];
}

export async function createAllowedDomain(body: AllowedDomainIn): Promise<AllowedDomain> {
  const { data } = await apiClient.post(`${BASE_URL}/allowed-domains`, body);
  return data.data;
}

export async function updateAllowedDomain(id: string, body: Partial<AllowedDomainIn>): Promise<AllowedDomain> {
  const { data } = await apiClient.patch(`${BASE_URL}/allowed-domains/${id}`, body);
  return data.data;
}

export async function deleteAllowedDomain(id: string): Promise<void> {
  await apiClient.delete(`${BASE_URL}/allowed-domains/${id}`);
}

// Export as v1AllowedDomainsApi for consistency with other v1 features
export const v1AllowedDomainsApi = {
  getAllowedDomains,
  createAllowedDomain,
  updateAllowedDomain,
  deleteAllowedDomain,
};